<mat-toolbar color="accent">
  <span>Create Referral</span>
</mat-toolbar>

<mat-dialog-content>
  <pr-referral-form
    [brand]="data.brand"
    [staffer]="data.staffer"
    [practice]="data.practice"
    [patient]="data.patient"
    (referralChange)="referralData.set($event)"
  />
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!referralData()"
      (click)="createReferral()"
    >
      Create
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
